import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentService } from '../environment/environment.service';
import { Router } from '@angular/router';
import { ErrorService } from '../error/error.service';
import { AbstractService } from '@app/shared/service/base/abstractService';

@Injectable({
  providedIn: 'root'
})
export class VersionService extends AbstractService {

  public baseBackUrl: string;

  constructor(
    private httpClient: HttpClient,
    private jwtService: JwtHelperService,
    public environmentService: EnvironmentService,
    public errorService: ErrorService,
    public router: Router
  ) {
    super(
      environmentService,
      router,
      errorService
    );
  }

  getVersion(): Observable<any> {
    const urlApi = this.baseBackUrl + 'api/Version';
    return this.httpClient.get(urlApi, {})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, false) ));
  }

}
